import { z } from 'zod';

export const OrganizerRatingParamId = z.enum(['atmosphere', 'organization', 'value']);
export type OrganizerRatingParamId = z.infer<typeof OrganizerRatingParamId>;

export const OrganizerRatingParamDto = z.object({
  id: OrganizerRatingParamId,
  /** Средний балл 1–10, null когда ответов нет. */
  avg: z.number().nullable(),
});
export type OrganizerRatingParamDto = z.infer<typeof OrganizerRatingParamDto>;

export const OrganizerPastEventDto = z.object({
  id: z.uuid(),
  title: z.string(),
  startsAt: z.iso.datetime(),
  coverUrl: z.string().nullable(),
  /** Количество отмеченных людей на групповых фото события. */
  photoParticipantsCount: z.number().int(),
});
export type OrganizerPastEventDto = z.infer<typeof OrganizerPastEventDto>;

export const OrganizerCityLeaderboardEntryDto = z.object({
  rank: z.number().int().positive(),
  organizerUserId: z.uuid(),
  displayName: z.string(),
  /** Положительные NPS (6–10) от активных за 14 дней в городе организатора. */
  positiveActiveCount: z.number().int().nonnegative(),
});
export type OrganizerCityLeaderboardEntryDto = z.infer<typeof OrganizerCityLeaderboardEntryDto>;

/** Публичный профиль организатора. Только данные — лейблы/эмодзи/подсказки живут на фронте. */
export const OrganizerPublicProfileDto = z.object({
  user: z.object({
    id: z.uuid(),
    displayName: z.string(),
    username: z.string().nullable(),
    photoUrl: z.string().nullable(),
    bio: z.string().nullable(),
    /** VIP-статус активен на момент чтения. Срок наружу не отдаётся. */
    isVip: z.boolean(),
  }),
  rating: z.object({
    /** Место среди организаторов города по positiveActiveCount; null если нет положительных оценок. */
    rank: z.number().int().positive().nullable(),
    /** Положительные NPS (6–10) от активных за 14 дней на событиях орга в его городе. */
    positiveActiveCount: z.number().int().nonnegative(),
    /** Среднее трёх параметров (1–10), null когда ответов нет. Только активные за 14 дней. */
    overallAvg: z.number().nullable(),
    /** NPS-ответы attended=true от активных за 14 дней. */
    responsesCount: z.number().int(),
    params: z.array(OrganizerRatingParamDto).length(3),
    /** Топ-3 организаторов города по positiveActiveCount. */
    cityLeaderboard: z.array(OrganizerCityLeaderboardEntryDto).max(3),
  }),
  pastEvents: z.array(OrganizerPastEventDto),
});
export type OrganizerPublicProfileDto = z.infer<typeof OrganizerPublicProfileDto>;
